import React, { useEffect, useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { BaseAddonCategoryType, BrandType } from 'utils/types';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { CreateAddonCategoryModal } from './create-addon-category-modal';
import Select from 'components/base/select';
import { multiselectOptionsType } from 'pages/meals/convert-meal-category-to-addon-category';
import { getBaseAddonCategory } from 'pages/base-items/util';

type formData = {
  name: string;
  parent_meals: string[] | [];
  base_addon_category_id: string;
};

const CreateAddonCategory = () => {
  const [loading, setLoading] = useState(false);
  const [baseAddonCategory, setBaseAddonCategory] = useState<BaseAddonCategoryType[]>([]);
  const [brandsList, setBrandsList] = useState([] as multiselectOptionsType[]);
  const { activeCokitchen, category } = useDashboardContext();
  const [parentMealList, setParentMealList] = useState([] as multiselectOptionsType[]);
  const [newCategory, setNewCategory] = useState({} as any);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [brand, setBrand] = useState([] as string[]);
  const [formData, setFormData] = useState({
    parent_meals: []
  } as formData);

  const fetchBaseAddonCategories = async () => {
    const categories = await getBaseAddonCategory(true);
    setBaseAddonCategory(categories);
  };
  useEffect(() => {
    fetchBaseAddonCategories();
  }, []);
  const fetchBrandData = async () => {
    try {
      const params = {
        cokitchen_id: activeCokitchen.id
      };
      const res = await apiService.get('brand_management/brands', {
        params
      });
      const brands = res?.data
        ?.filter((b: BrandType) => b.item_type === category.toUpperCase() && !b.archived)
        .map((brand: BrandType) => ({
          text: brand?.name,
          value: brand?.id
        }));
      setBrandsList(brands);
    } catch {
      setBrandsList([]);
    }
  };

  const fetchParentMeals = async () => {
    try {
      const res = await apiService.post(`meals`, {
        data: { brand_ids: brand },
        isInternal: true
      });
      const meals = res.data.data;
      const parentMealsList = meals.map((parentMeal: any) => {
        return {
          value: {
            meal_parent_id: parentMeal?.id,
            meal_category_id: parentMeal?.meal_category?.id
          },
          text: `${parentMeal?.brand?.name} - ${parentMeal?.name}`
        };
      });
      setParentMealList(parentMealsList);
    } catch {
      setParentMealList([]);
    }
  };

  const onConfirm = async () => {
    setLoading(true);
    try {
      const payload = formData;
      const res = await apiService.post('marketing/meal-addon-category', {
        data: payload
      });
      const response = res.data.data[0];
      setNewCategory({
        addon_category: { text: response.name, value: response.id },
        meal: { text: response.meal.name, value: response.meal.id },
        brand: { text: response.meal.brand.name, value: response.meal.brand.id }
      });
      setShowSuccessModal(true);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchParentMeals();
  }, [brand]);

  useEffect(() => {
    fetchBrandData();
  }, [activeCokitchen]);
  return (
    <div>
      <PageHeaderText
        title='Create New Add-on Category'
        description='Ensure you provide correct details'
      />
      <div className='w-[48em]'>
        <div className='mb-[24px] '>
          <p className='font-medium text-sm'>Select Brand(s)</p>
          <Select
            multiple
            placeholder='Select brand(s)'
            values={brand}
            options={brandsList}
            onChange={setBrand}
          />
        </div>

        <div className='mb-[24px]'>
          <p className='font-medium text-sm'>Select Parent meal(s)</p>
          <Select
            multiple
            placeholder='Select parent meal(s)'
            values={formData?.parent_meals}
            options={parentMealList}
            onChange={(k) => setFormData({ ...formData, parent_meals: k })}
          />
        </div>
        <div>
          <p className='text-xs'>Base addon category</p>
          <Select
            small
            hasSearch
            value={formData.base_addon_category_id}
            options={baseAddonCategory?.map((item) => {
              return { value: item.id, text: item.name };
            })}
            placeholder='Select base addon category'
            onChange={(v) => setFormData({ ...formData, base_addon_category_id: v })}
          />
        </div>

        <SingleBottomNav
          onConfirm={onConfirm}
          btnDisabled={formData?.parent_meals?.length === 0}
          loading={loading}
        />
      </div>

      <CreateAddonCategoryModal
        onClose={() => setShowSuccessModal(false)}
        show={showSuccessModal}
        addons={newCategory}
      />
    </div>
  );
};

export default CreateAddonCategory;
